module.exports = __webpack_public_path__ + "static/media/font_medium.63ce023b.woff";